import { useState, useEffect } from 'react'
import { Button, Popup, Tag, Toast, Loading, Empty, Dialog } from 'react-vant'
import { useNavigate } from 'react-router-dom'
import teacherAffairsApi from '../../../api/teacherAffairs'

const OT_TYPE_MAP = { workday: '工作日', weekend: '周末', holiday: '节假日' }
const OT_TYPE_COLOR = { workday: '#056b4f', weekend: '#fa8c16', holiday: '#e11d48' }
const STATUS_MAP = {
  pending: { label: '待审批', color: '#fa8c16', bg: '#fffbeb' },
  approved: { label: '已通过', color: '#00b578', bg: '#ecfdf5' },
  rejected: { label: '已驳回', color: '#e11d48', bg: '#fff1f2' },
  auto_approved: { label: '自动通过', color: '#00b578', bg: '#ecfdf5' },
}

export default function OvertimePage() {
  const navigate = useNavigate()
  const [records, setRecords] = useState([])
  const [loading, setLoading] = useState(false)
  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(1)
  const [stats, setStats] = useState({ total_hours: 0 })
  const [showForm, setShowForm] = useState(false)
  const [editRecord, setEditRecord] = useState(null)
  const [formDate, setFormDate] = useState('')
  const [formStartTime, setFormStartTime] = useState('')
  const [formEndTime, setFormEndTime] = useState('')
  const [formHours, setFormHours] = useState('')
  const [formType, setFormType] = useState('workday')
  const [formReason, setFormReason] = useState('')

  useEffect(() => { fetchRecords(); fetchStats() }, [page])

  const fetchRecords = async () => {
    setLoading(true)
    try {
      const res = await teacherAffairsApi.getOvertimeList({ page, page_size: 20 })
      setRecords(res?.items || [])
      setTotal(res?.total || 0)
    } catch (e) { console.error(e) }
    finally { setLoading(false) }
  }

  const fetchStats = async () => {
    try {
      const now = new Date()
      const res = await teacherAffairsApi.getOvertimeStats({
        start_date: `${now.getFullYear()}-01-01`, end_date: `${now.getFullYear()}-12-31`,
      })
      setStats(res || { total_hours: 0 })
    } catch (e) { /* ignore */ }
  }

  const resetForm = () => {
    setFormDate(''); setFormStartTime(''); setFormEndTime('')
    setFormHours(''); setFormType('workday'); setFormReason(''); setEditRecord(null)
  }

  const openForm = (record = null) => {
    if (record) {
      setEditRecord(record); setFormDate(record.overtime_date)
      setFormStartTime(record.start_time); setFormEndTime(record.end_time)
      setFormHours(String(record.duration_hours)); setFormType(record.overtime_type)
      setFormReason(record.reason)
    } else { resetForm() }
    setShowForm(true)
  }

  const calcHours = (start, end) => {
    if (!start || !end) return
    const [sh, sm] = start.split(':').map(Number)
    const [eh, em] = end.split(':').map(Number)
    const h = (eh * 60 + em - sh * 60 - sm) / 60
    if (h > 0) setFormHours(String(Math.round(h * 10) / 10))
  }

  const handleSubmit = async () => {
    if (!formDate || !formStartTime || !formEndTime || !formHours || !formReason) {
      Toast.info('请填写完整信息'); return
    }
    try {
      const data = { overtime_date: formDate, start_time: formStartTime, end_time: formEndTime,
        duration_hours: parseFloat(formHours), overtime_type: formType, reason: formReason }
      if (editRecord) { await teacherAffairsApi.updateOvertime(editRecord.id, data); Toast.success('修改成功') }
      else { await teacherAffairsApi.createOvertime(data); Toast.success('提交成功') }
      setShowForm(false); resetForm(); fetchRecords(); fetchStats()
    } catch (e) { Toast.fail(e.response?.data?.detail || '提交失败') }
  }

  const handleDelete = async (id) => {
    try {
      await Dialog.confirm({ title: '确认删除', message: '确认删除该加班记录？' })
      await teacherAffairsApi.deleteOvertime(id)
      Toast.success('删除成功'); fetchRecords(); fetchStats()
    } catch (e) { if (e !== 'cancel') Toast.fail('删除失败') }
  }

  const inputStyle = { width: '100%', padding: '10px 12px', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }

  return (
    <div style={{ background: '#f5f8f6', minHeight: '100vh', paddingBottom: 80 }}>
      <div style={{
        background: '#056b4f', padding: '12px 16px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <div onClick={() => navigate(-1)} style={{ cursor: 'pointer', padding: 4 }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </div>
        <span style={{ fontSize: 17, fontWeight: 700, color: '#fff' }}>我的加班</span>
        <div style={{ width: 24 }} />
      </div>

      {/* 概览 Banner（三页统一结构与高度） */}
      <div style={{ background: 'linear-gradient(135deg, #055e43 0%, #076f51 50%, #0c8c68 100%)', padding: '0 16px 28px', borderRadius: '0 0 24px 24px', color: '#fff' }}>
        <div style={{ display: 'flex', gap: 12 }}>
          <div style={{ flex: 1, background: 'rgba(255,255,255,0.2)', borderRadius: 14, padding: '14px 16px' }}>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.85)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>本年累计</div>
            <div style={{ fontSize: 26, fontWeight: 700, color: '#fff', marginTop: 4 }}>{stats.total_hours || 0}<span style={{ fontSize: 13, fontWeight: 400 }}> 小时</span></div>
          </div>
          <div style={{ flex: 1, background: 'rgba(255,255,255,0.2)', borderRadius: 14, padding: '14px 16px' }}>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.85)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>记录数</div>
            <div style={{ fontSize: 26, fontWeight: 700, color: '#fff', marginTop: 4 }}>{total}<span style={{ fontSize: 13, fontWeight: 400 }}> 条</span></div>
          </div>
          <div style={{ flex: 1, background: 'rgba(255,255,255,0.2)', borderRadius: 14, padding: '14px 16px' }}>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.85)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>待审批</div>
            <div style={{ fontSize: 26, fontWeight: 700, color: '#fff', marginTop: 4 }}>{records.filter(r => r.approval_status === 'pending').length}<span style={{ fontSize: 13, fontWeight: 400 }}> 条</span></div>
          </div>
        </div>
      </div>

      {/* 列表 */}
      <div style={{ padding: '16px 12px' }}>
        {loading ? <div style={{ textAlign: 'center', padding: 40 }}><Loading size={24} /></div>
        : records.length === 0 ? <Empty description="暂无加班记录" />
        : records.map(item => {
          const st = STATUS_MAP[item.approval_status] || STATUS_MAP.pending
          return (
            <div key={item.id} style={{ background: '#fff', borderRadius: 12, padding: 14, marginBottom: 10, boxShadow: '0 1px 6px rgba(0,0,0,0.04)', borderLeft: `3px solid ${OT_TYPE_COLOR[item.overtime_type] || '#056b4f'}` }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                <span style={{ fontSize: 15, fontWeight: 600 }}>{item.overtime_date}</span>
                <Tag plain style={{ color: st.color, borderColor: st.color, background: st.bg, fontSize: 11 }}>{st.label}</Tag>
              </div>
              <div style={{ fontSize: 13, color: '#64748b', marginBottom: 4 }}>⏰ {item.start_time} - {item.end_time} <span style={{ fontWeight: 600, color: '#334155', marginLeft: 8 }}>{item.duration_hours}h</span></div>
              <div style={{ fontSize: 13, color: '#64748b' }}>{OT_TYPE_MAP[item.overtime_type]} · {item.reason}</div>
              {item.rejection_reason && <div style={{ fontSize: 12, color: '#e11d48', marginTop: 4 }}>驳回：{item.rejection_reason}</div>}
              {item.approval_status === 'pending' && (
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 8 }}>
                  <Button size="mini" plain onClick={() => openForm(item)}>编辑</Button>
                  <Button size="mini" type="danger" plain onClick={() => handleDelete(item.id)}>删除</Button>
                </div>
              )}
            </div>
          )
        })}
      </div>

      {/* 浮动按钮 */}
      <div style={{ position: 'fixed', bottom: 24, right: 20, zIndex: 100 }}>
        <Button round type="primary"
          style={{ background: '#056b4f', border: 'none', boxShadow: '0 4px 16px rgba(5,107,79,0.35)', width: 52, height: 52, fontSize: 24, color: '#fff' }}
          onClick={() => openForm()}>+</Button>
      </div>

      {/* 表单弹窗 */}
      <Popup visible={showForm} position="bottom" round closeable onClose={() => { setShowForm(false); resetForm() }} style={{ maxHeight: '85vh' }}>
        <div style={{ padding: '20px 16px 32px' }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 17, fontWeight: 700 }}>{editRecord ? '编辑加班' : '填报加班'}</h3>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 14, color: '#475569', marginBottom: 6, display: 'block' }}>加班日期 *</label>
            <input type="date" value={formDate} onChange={e => setFormDate(e.target.value)} style={inputStyle} />
          </div>
          <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 14, color: '#475569', marginBottom: 6, display: 'block' }}>开始 *</label>
              <input type="time" value={formStartTime} onChange={e => { setFormStartTime(e.target.value); calcHours(e.target.value, formEndTime) }} style={inputStyle} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 14, color: '#475569', marginBottom: 6, display: 'block' }}>结束 *</label>
              <input type="time" value={formEndTime} onChange={e => { setFormEndTime(e.target.value); calcHours(formStartTime, e.target.value) }} style={inputStyle} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 14, color: '#475569', marginBottom: 6, display: 'block' }}>时长(h) *</label>
              <input type="number" step="0.5" min="0.5" value={formHours} onChange={e => setFormHours(e.target.value)} style={inputStyle} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: 14, color: '#475569', marginBottom: 6, display: 'block' }}>类型 *</label>
              <select value={formType} onChange={e => setFormType(e.target.value)} style={{ ...inputStyle, background: '#fff' }}>
                <option value="workday">工作日</option><option value="weekend">周末</option><option value="holiday">节假日</option>
              </select>
            </div>
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ fontSize: 14, color: '#475569', marginBottom: 6, display: 'block' }}>原因 *</label>
            <textarea value={formReason} onChange={e => setFormReason(e.target.value)} placeholder="至少2字" rows={3} style={{ ...inputStyle, resize: 'none' }} />
          </div>
          <Button type="primary" block round size="large" onClick={handleSubmit}>{editRecord ? '保存修改' : '提交加班'}</Button>
        </div>
      </Popup>
    </div>
  )
}
